/* eslint-disable */
import { Logo } from './components/logo';
import { default as AdminElementProd } from '../assets/logos/Admin_prod.svg?react';
import { default as AdminElementUat } from '../assets/logos/Admin_uat.svg?react';
import { default as AideITElementProd } from '../assets/logos/AideIT_prod.svg?react';
import { default as AideITElementUat } from '../assets/logos/AideIT_uat.svg?react';
import { default as BriefDePosteElementProd } from '../assets/logos/BriefDePoste_prod.svg?react';
import { default as BriefDePosteElementUat } from '../assets/logos/BriefDePoste_uat.svg?react';
import { default as EtudeDePosteElementProd } from '../assets/logos/EtudeDePoste_prod.svg?react';
import { default as EtudeDePosteElementUat } from '../assets/logos/EtudeDePoste_uat.svg?react';
import { default as FlashElementProd } from '../assets/logos/Flash_prod.svg?react';
import { default as FlashElementUat } from '../assets/logos/Flash_uat.svg?react';
import { default as FlashmedElementProd } from '../assets/logos/Flashmed_prod.svg?react';
import { default as FlashmedElementUat } from '../assets/logos/Flashmed_uat.svg?react';
import { default as PayrollElementProd } from '../assets/logos/Payroll_prod.svg?react';
import { default as PayrollElementUat } from '../assets/logos/Payroll_uat.svg?react';
import { default as PigeElementProd } from '../assets/logos/Pige_prod.svg?react';
import { default as PigeElementUat } from '../assets/logos/Pige_uat.svg?react';
import { default as PortailMobiliteElementProd } from '../assets/logos/PortailMobilite_prod.svg?react';
import { default as PortailMobiliteElementUat } from '../assets/logos/PortailMobilite_uat.svg?react';
import { default as PulseElementProd } from '../assets/logos/Pulse_prod.svg?react';
import { default as PulseElementUat } from '../assets/logos/Pulse_uat.svg?react';
import { default as PuzzleElementProd } from '../assets/logos/Puzzle_prod.svg?react';
import { default as PuzzleElementUat } from '../assets/logos/Puzzle_uat.svg?react';
import { default as RandyElementProd } from '../assets/logos/Randy_prod.svg?react';
import { default as RandyElementUat } from '../assets/logos/Randy_uat.svg?react';
import { default as RecrutliveElementProd } from '../assets/logos/Recrutlive_prod.svg?react';
import { default as RecrutliveElementUat } from '../assets/logos/Recrutlive_uat.svg?react';
import { default as SatisfactionElementProd } from '../assets/logos/Satisfaction_prod.svg?react';
import { default as SatisfactionElementUat } from '../assets/logos/Satisfaction_uat.svg?react';
import { default as ScopeElementProd } from '../assets/logos/Scope_prod.svg?react';
import { default as ScopeElementUat } from '../assets/logos/Scope_uat.svg?react';
import { default as TourDeProdElementProd } from '../assets/logos/TourDeProd_prod.svg?react';
import { default as TourDeProdElementUat } from '../assets/logos/TourDeProd_uat.svg?react';

export const Admin = Logo(AdminElementProd, AdminElementUat);
export const AideIT = Logo(AideITElementProd, AideITElementUat);
export const BriefDePoste = Logo(BriefDePosteElementProd, BriefDePosteElementUat);
export const EtudeDePoste = Logo(EtudeDePosteElementProd, EtudeDePosteElementUat);
export const Flash = Logo(FlashElementProd, FlashElementUat);
export const Flashmed = Logo(FlashmedElementProd, FlashmedElementUat);
export const Payroll = Logo(PayrollElementProd, PayrollElementUat);
export const Pige = Logo(PigeElementProd, PigeElementUat);
export const PortailMobilite = Logo(PortailMobiliteElementProd, PortailMobiliteElementUat);
export const Pulse = Logo(PulseElementProd, PulseElementUat);
export const Puzzle = Logo(PuzzleElementProd, PuzzleElementUat);
export const Randy = Logo(RandyElementProd, RandyElementUat);
export const Recrutlive = Logo(RecrutliveElementProd, RecrutliveElementUat);
export const Satisfaction = Logo(SatisfactionElementProd, SatisfactionElementUat);
export const Scope = Logo(ScopeElementProd, ScopeElementUat);
export const TourDeProd = Logo(TourDeProdElementProd, TourDeProdElementUat);
